import Commerce from "pages/commerce";
import CompanyInfo from "pages/companyInfo";
import Employment from "pages/employment";
import Esg from "pages/esg";
import Home from "pages/home";
import Inquiry from "pages/inquiry";
import Mallpie from "pages/mallpie";
import MallpieBiz from "pages/mallpieBiz";
import Marketing from "pages/marketing";
import Message from "pages/message";
import Detail from "pages/news/detail";
import NewsList from "pages/news/list";
import NewsVideo from "pages/news/video";
import Travel from "pages/travel";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "styles/reset.css";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/news/list",
    element: <NewsList newsType="image" />,
  },
  {
    path: "/news/video",
    element: <NewsVideo newsType="video" />,
  },
  {
    path: "/news/list/:id",
    element: <Detail detailType="image" />,
  },
  {
    path: "/news/video/:id",
    element: <Detail detailType="video" />,
  },
  {
    path: "/inquiry",
    element: <Inquiry />,
  },
  {
    path: "/companyInfo",
    element: <CompanyInfo />,
  },
  {
    path: "/business/mallpie",
    element: <Mallpie />,
  },
  {
    path: "/business/mallpiebiz",
    element: <MallpieBiz />,
  },
  {
    path: "/business/commerce",
    element: <Commerce />,
  },
  {
    path: "/business/marketing",
    element: <Marketing />,
  },
  {
    path: "/business/message",
    element: <Message />,
  },
  {
    path: "/business/travel",
    element: <Travel />,
  },
  {
    path: "/employment",
    element: <Employment />,
  },
  {
    path: "/esg",
    element: <Esg />,
  },
  {
    path: "/esg",
    element: <Esg />,
  },
]);

const App = () => {
  return (
    <>
      <RouterProvider router={router} />
    </>
  );
};

export default App;
